import React from 'react';
import propTypes from './propTypes';

const TurnoverReport = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.65456 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12.5903C20.4099 13.1184 19.7357 13.5545 19 13.8759V19H5V5H8.76962C8.96701 4.2848 9.26768 3.61245 9.65456 3Z" fill="currentColor" />
    <path d="M9.125 11L10.625 13H7V11H9.125Z" fill="currentColor" />
    <path d="M14 17H7V15H14V17Z" fill="currentColor" />
    <path d="M18.1426 1.39388C17.4772 1.13941 16.7549 1 16 1C12.6863 1 10 3.68629 10 7H8L11 11L14 7L12 7C12 4.79086 13.7909 3 16 3C16.295 3 16.5826 3.03195 16.8595 3.09257L18.1426 1.39388Z" fill="currentColor" />
    <path d="M15.1017 10.8987C15.3905 10.965 15.6911 11 16 11C18.2091 11 20 9.20914 20 7L18 7L21 3L24 7L22 7C22 10.3137 19.3137 13 16 13C15.2318 13 14.4974 12.8556 13.8223 12.5926L15.1017 10.8987Z" fill="currentColor" />
  </svg>
);

TurnoverReport.propTypes = propTypes;

export default TurnoverReport;
